import { Modal, VStack } from '@musinsa/mwms-ds'
import { ForwardedRef, forwardRef, PropsWithChildren } from 'react'
import Text from '@/components/content/Text'

interface Props extends PropsWithChildren {
  title: string
  description?: string
  content?: React.ReactNode
  footer?: React.ReactNode
}

/**
 *  action을 사용해 렌더링할거라 default open처리
 */
function _ConfirmModal({ title, description, content, footer }: Props, ref: ForwardedRef<HTMLDivElement>) {
  return (
    <Modal open ref={ref}>
      <VStack gap={24} align="center">
        <VStack gap={8} align="center" style={{ textAlign: 'center' }}>
          <Text
            kind="Headline_20_bold"
            style={{
              whiteSpace: 'pre-line',
            }}
          >
            {title}
          </Text>
          {description && <Text kind="Body_14_regular">{description}</Text>}
        </VStack>
        {content}
        {footer}
      </VStack>
    </Modal>
  )
}

export const ConfirmModal = forwardRef(_ConfirmModal)
